module.exports = __webpack_public_path__ + "img/red-cancel-icon.23ef90bf.svg";